<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M383 1218 c-50 -54 -20 -128 51 -128 26 0 40 7 56 27 57 72 -45 167
-107 101z"
      />
      <path
        d="M1068 1172 c-65 -37 -117 -69 -118 -72 0 -3 18 -14 40 -24 22 -11 40
-24 40 -30 0 -20 -102 -148 -194 -244 -205 -214 -452 -349 -674 -369 l-73 -6
3 -31 3 -31 60 4 c150 8 362 90 514 198 98 70 270 241 352 352 l72 98 44 -25
c24 -13 46 -22 49 -20 2 3 3 64 2 136 l-3 130 -117 -66z"
      />
      <path
        d="M195 1188 c-53 -28 -62 -98 -19 -142 33 -32 54 -33 88 -1 63 58 3
183 -69 143z m63 -50 c7 -7 12 -21 12 -31 0 -14 -4 -17 -17 -12 -23 10 -43 10
-65 0 -14 -5 -18 -2 -18 12 0 14 10 23 33 31 43 14 41 14 55 0z m-10 -54 c29
-8 28 -22 -3 -36 -19 -8 -31 -8 -50 0 -29 13 -32 29 -7 35 26 7 35 7 60 1z"
      />
      <path
        d="M613 1190 c-47 -19 -53 -95 -12 -139 36 -39 74 -23 104 42 21 44 10
77 -32 96 -28 13 -30 13 -60 1z m41 -50 c-20 -20 -43 2 -25 24 10 12 16 13 26
3 11 -10 11 -14 -1 -27z m29 -29 c13 -2 7 -28 -11 -51 -23 -28 -58 -20 -75 17
-17 37 5 46 86 34z"
      />
      <path
        d="M302 1037 c-8 -10 -8 -47 0 -135 10 -106 14 -126 35 -148 21 -23 23
-34 23 -134 0 -60 4 -111 8 -114 5 -3 36 8 69 23 l61 29 7 94 c5 73 11 96 26
108 15 12 21 39 30 137 14 153 14 153 -87 153 -68 0 -75 -2 -91 -26 -13 -21
-14 -29 -5 -43 32 -44 36 -61 18 -79 -16 -16 -17 -16 -11 11 7 26 -7 57 -26
57 -16 0 -31 -40 -20 -54 11 -13 5 -26 -11 -26 -13 0 -9 62 6 79 7 9 18 31 24
49 11 31 10 32 -17 32 -16 0 -33 -6 -39 -13z m221 -110 c3 -8 2 -20 -3 -27 -6
-10 -11 -10 -22 1 -11 10 -12 17 -4 26 14 16 23 16 29 0z"
      />
      <path
        d="M105 994 c-11 -12 -15 -27 -11 -53 3 -20 8 -71 11 -114 5 -57 11 -80
24 -90 15 -10 19 -34 25 -122 4 -60 12 -116 18 -122 14 -17 83 -16 97 1 6 7
14 62 18 122 3 60 10 112 16 115 6 4 5 13 -1 25 -5 11 -13 60 -16 109 -12 155
-6 145 -91 145 -55 0 -78 -4 -90 -16z m88 -46 c5 -18 -3 -48 -14 -48 -5 0 -9
6 -9 13 0 8 -3 7 -10 -3 -8 -12 -10 -12 -16 3 -3 9 -4 24 0 32 7 18 43 20 49
3z"
      />
      <path
        d="M590 988 c-1 -60 -21 -212 -31 -231 -9 -16 -9 -22 0 -25 6 -2 11 -16
11 -32 0 -15 3 -41 6 -58 l6 -31 42 28 c22 16 61 48 85 71 l43 42 11 116 c13
140 11 142 -100 142 -69 0 -73 -1 -73 -22z"
      />
      <path
        d="M986 814 c-3 -9 -6 -183 -6 -388 0 -276 3 -375 12 -384 16 -16 140
-16 156 0 9 9 12 108 12 384 0 205 -3 379 -6 388 -9 23 -159 23 -168 0z"
      />
      <path
        d="M705 528 c-3 -7 -4 -121 -3 -253 l3 -240 80 0 80 0 0 250 0 250 -78
3 c-57 2 -79 -1 -82 -10z"
      />
      <path
        d="M422 382 c-9 -6 -12 -49 -10 -178 l3 -169 80 0 80 0 0 175 0 175 -70
3 c-38 1 -76 -2 -83 -6z"
      />
      <path
        d="M126 274 c-11 -30 -7 -219 6 -232 16 -16 140 -16 156 0 13 13 17 202
6 232 -9 23 -159 23 -168 0z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
